/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node, INodeProps, Waiting } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { AfricaCheckout } from '../lds-checkout-shipping-address-4/components/customShippingSections/AfricaShipping';
import { BrazilCheckout } from '../lds-checkout-shipping-address-4/components/customShippingSections/BrazilShipping';
import { PeruCheckout } from '../lds-checkout-shipping-address-4/components/customShippingSections/PeruShipping';
import { ChileCheckout } from '../lds-checkout-shipping-address-4/components/customShippingSections/ChileShipping';
import { UruguayCheckout } from '../lds-checkout-shipping-address-4/components/customShippingSections/UruguayShipping';
import { stateCheckListChl } from '../lds-checkout-shipping-address-4/components/countryFilterLists.tsx/Chile';

import {
    IAddressAddItem,
    IAddressAddUpdateProps
} from '@msdyn365-commerce-modules/address/src/modules/account-management-address/../../common/components/address-add';
import {
    IAddressList,
    IAddressListItem,
    IAddressListProps
} from '@msdyn365-commerce-modules/address/src/modules/account-management-address/../../common/components/address-list';
import {
    IAddressShowItem,
    IAddressShowProps
} from '@msdyn365-commerce-modules/address/src/modules/account-management-address/../../common/components/address-show';
import { IAccountManagementAddressViewProps } from './lds-account-management-address';
import { IAddressError } from '../../modules/lds-checkout-shipping-address-4/components/address/address-add';
//@ts-ignore
import { Primary, Secondary, Ghost } from '@churchofjesuschrist/eden-buttons';
//@ts-ignore
import { Error, Info } from '@churchofjesuschrist/eden-alert';
//@ts-ignore
import { Edit, Add, Delete } from '@churchofjesuschrist/eden-icons';

import { stateNameTranslationAsync, countryStateTranslationAsync } from '../../actions/DataActionExtension.g';

import {
    stateCheckListMixed,
    stateCheckList,
    stateCheckListKo,
    cityCheck,
    ArgState
} from '../../helpers/utilities/state-address-utilities';

export interface AddressFormProps extends React.Component<IAddressAddUpdateProps> {
    AddressForm: INodeProps;
    heading: React.ReactNode;
    items: IAddressAddItem[];
    hasError: boolean;
    error: IAddressError;
    isShowSaveButton: boolean;
    saveButton: React.ReactNode;
    isShowCancelButton: boolean;
    cancelButton: React.ReactNode;
    isFinalSubmit: boolean;
    // getSmarty: any;
    smartyAddress: any;
    final: any;
    inputAddress: any;
    saveAddress: any;
}
export interface ILDSAddressListProps extends IAddressListProps {
    resources: any;
    setIsVisible: any;
    isDuplicate: any;
    context?: any;
}
export interface ILDSAddressList extends IAddressList {
    setIsVisible: any;
    isDuplicate: any;
    context?: any;
}

export interface ILDSAddressShowProps extends IAddressShowProps {
    context?: any;
}

/**
 * Address show component.
 * @param param0 - Root param.
 * @param param0.AddressDetail - Address detail.
 * @param param0.items - IAddressShowItem[].
 * @returns - Address Node.
 */
const AddressShow: React.FC<ILDSAddressShowProps> = ({ AddressDetail, items, context }) => {
    const [stateName, setStateName] = React.useState('');
    const [filteredList, setFilteredList] = React.useState([]);
    let filteredItems: any;

    const getStateTranslation = async (stateName: any, countryId: any) => {
        const ctx = { callerContext: context.actionContext };

        let translation;
        if (stateName && stateName[0] && countryId && countryId[0]) {
            translation = await stateNameTranslationAsync(
                ctx,
                countryId[0].description.props.value,
                stateName[0].description.props.value,
                context.request.locale
            );
        }

        if (translation && translation.DisplayName) {
            setStateName(translation.DisplayName);
        }
    };
    React.useEffect(() => {
        let filteredStateList: any;
        const findState = items.filter((item: any) => {
            return item.key === 'State';
        });
        const findCountry = items.filter((item: any) => {
            return item.key === 'ThreeLetterISORegionName';
        });
        void getStateTranslation(findState, findCountry);
        if (findState && findState[0] && findCountry && findCountry[0]) {
            // @ts-ignore
            if (findCountry[0].description.props.value === 'KOR') {
                // @ts-ignore
                filteredStateList = stateCheckListMixed.some(item => item.value === findState[0].description.props.value);
                if (filteredStateList === true) {
                    filteredItems = items.filter((item: any) => {
                        return item.key !== 'City';
                    });
                    setFilteredList(filteredItems);
                }
                // @ts-ignore
            } else if (findCountry[0].description.props.value === 'VNM') {
                // @ts-ignore
                filteredStateList = filteredStateList = cityCheck.includes(findState[0].description.props.value);

                if (filteredStateList === true) {
                    filteredItems = items.filter((item: any) => {
                        return item.key !== 'City';
                    });
                    setFilteredList(filteredItems);
                }
            }
        }
    }, []);

    return (
        <Node {...AddressDetail}>
            {filteredList && filteredList.length > 0
                ? filteredList.map((item: IAddressShowItem) => {
                      if (item.key === 'State' && stateName) {
                          return (
                              <span
                                  key={item.key}
                                  className='msc-address-detail__item msc-address-detail__item-state msc-address-detail__item-newline'
                              >
                                  {stateName}
                              </span>
                          );
                      } else {
                          return <>{item.description}</>;
                      }
                  })
                : items.map((item: IAddressShowItem) => {
                      if (item.key === 'State' && stateName) {
                          return (
                              <span
                                  key={item.key}
                                  className='msc-address-detail__item msc-address-detail__item-state msc-address-detail__item-newline'
                              >
                                  {stateName}
                              </span>
                          );
                      } else {
                          return <>{item.description}</>;
                      }
                  })}
        </Node>
    );
};

/**
 * Address List Component.
 * @param param0 - Root param.
 * @param param0.List - Address list.
 * @param param0.isShowList - Boolean.
 * @param param0.heading - Address heading.
 * @param param0.items - IAddressListItem[].
 * @returns - AddressListComponent Node.
 */
const AddressList: React.FC<ILDSAddressList> = ({ List, isShowList, heading, items, isDuplicate, setIsVisible, context }) => {
    const onClickFunction = (functionToExecute: any) => {
        functionToExecute();
        isDuplicate(false);
    };

    const onClickFunctionEdit = (functionToExecute: any) => {
        functionToExecute();
        setIsVisible(false);
    };
    if (!isShowList) {
        return null;
    }

    return (
        <Node {...List}>
            {/* {heading} */}
            {items.map((item: IAddressListItem) => {
                // const { Item, key, error, showItems, isShowPrimaryButton, primaryButton, editButton, removeButton } = item;
                const { Item, key, error, showItems, editButton, removeButton } = item;
                // const { Item, key, error, showItems, isShowPrimaryButton, primaryButton, removeButton } = item;
                const { Error, isShowError, title, message } = error;
                return (
                    <Node {...Item} key={key}>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                width: '100%',
                                height: '100%',
                                paddingLeft: '10px',
                                paddingRight: '10px'
                            }}
                        >
                            <AddressShow {...showItems} context={context} />
                            {isShowError && (
                                <Node {...Error}>
                                    {title}
                                    {message}
                                </Node>
                            )}
                            <div style={{ display: 'flex', width: '50%', flexDirection: 'column' }}>
                                {editButton && (
                                    <>
                                        <div
                                            style={{
                                                color: '#006484',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                                width: '100%',
                                                height: '100%'
                                            }}
                                            // @ts-ignore
                                            onClick={() => onClickFunctionEdit(editButton.props.onClick)}
                                        >
                                            <Edit size='1.5rem' />
                                        </div>
                                    </>
                                )}
                                {/* {removeButton} */}
                                {removeButton && (
                                    <>
                                        <div
                                            // @ts-ignore
                                            onClick={() => onClickFunction(removeButton.props.onClick)}
                                            style={{
                                                color: '#006484',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                                width: '100%',
                                                height: '100%'
                                            }}
                                        >
                                            <Delete size='1.5rem' />
                                        </div>
                                    </>
                                )}
                                {/* </div> */}
                            </div>
                        </div>
                    </Node>
                );
            })}
        </Node>
    );
};

/**
 * Address Lists Component.
 * @param param0 - Root param.
 * @param param0.ListAddress - List address.
 * @param param0.heading - List heading.
 * @param param0.isShowEmptyListMessage - Boolean.
 * @param param0.emptyListMessage - Empty list message.
 * @param param0.addButton - Add button.
 * @param param0.primaryAddressList - Primary address.
 * @param param0.otherAddressList - Other address.
 * @returns Address Lists Component Node.
 */
const AddressLists: React.FC<ILDSAddressListProps> = ({
    ListAddress,
    heading,
    isShowEmptyListMessage,
    emptyListMessage,
    addButton,
    primaryAddressList,
    otherAddressList,
    resources,
    setIsVisible,
    isDuplicate,
    context
}) => {
    const onClickFunction = (functionToExecute: any) => {
        functionToExecute();
        setIsVisible(false);
    };
    return (
        <Node {...ListAddress}>
            {/* {heading} */}
            {isShowEmptyListMessage && emptyListMessage}
            {/* {addButton} */}
            {addButton && (
                <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        borderTop: '1px solid #000000',
                        paddingTop: '20px',
                        paddingRight: '10px',
                        paddingLeft: '10px'
                    }}
                >
                    <h2 style={{ width: '100%' }}>{resources.addNewAddressText}</h2>
                    <div
                        style={{ color: '#006484', cursor: 'pointer', display: 'flex', justifyContent: 'flex-end', width: '100%' }}
                        /* @ts-ignore */
                        onClick={() => onClickFunction(addButton.props.onClick)}
                    >
                        <Add size='1.5rem' />
                    </div>
                </div>
            )}
            <AddressList {...primaryAddressList} setIsVisible={setIsVisible} isDuplicate={isDuplicate} context={context} />
            <AddressList {...otherAddressList} setIsVisible={setIsVisible} isDuplicate={isDuplicate} context={context} />
        </Node>
    );
};

/**
 * AddressAddUpdateComponent.
 * @param param0 - Root param.
 * @param param0.AddressForm - Address form.
 * @param param0.heading - Address heading.
 * @param param0.items - IAddressAddItem[].
 * @param param0.hasError - Boolean.
 * @param param0.error - Error message.
 * @param param0.isShowSaveButton - Boolean.
 * @param param0.saveButton - Save button.
 * @param param0.isShowCancelButton - Boolean.
 * @param param0.cancelButton - Cancel button.
 * @returns Address add update component node.
 */
const AddressAddUpdate: React.FC<any> = props => {
    const {
        AddressForm,
        heading,
        items,
        hasError,
        error,
        // isShowSaveButton,
        saveButton,
        // isShowCancelButton,
        cancelButton,
        resources,
        defaultCountryRegionId,
        context,
        showSmarty,
        smartyFailed,
        smartyAddress,
        userAddress,
        loading,
        userAddressCustom
    } = props;

    const [inputAddress, setInputAddress] = React.useState<any>({});
    const [isVisible, setIsVisible] = React.useState<any>(false);
    const [isDisabled, setIsDisabled] = React.useState<any>(true);
    const [customDisabled, setCustomDisabled] = React.useState<any>(true);
    const [unitName, setUnitName] = React.useState<any>('');
    const [stakeNameAddress, setStakeNameAddress] = React.useState<any>('');
    const [disabled, setDisabled] = React.useState<any>(true);
    const [hideCity, setHideCity] = React.useState<any>(false);
    const [updatedStateList, setUpdatedStateList] = React.useState<any>([]);

    const updateNames = (array1: any, array2: any) => {
        return array1.map((item1: any) => {
            const match = array2.find((item2: any) => {
                return item2.StateId === item1.key;
            });
            if (match && match.LongName !== '') {
                return { ...item1, value: match.LongName };
            }
            return item1;
        });
    };

    const stateListTranslation = async (stateList: any) => {
        let translatedStateList;
        const ctx = { callerContext: context.actionContext };

        const response = await countryStateTranslationAsync(ctx, defaultCountryRegionId, props.context.request.locale).catch((err: any) => {
            return console.log(err);
        });

        if (stateList && stateList.length !== 0) {
            translatedStateList = updateNames(stateList, response);
        }

        if (translatedStateList && translatedStateList.length > 0) {
            translatedStateList.filter((option: any) => {
                return option.value !== '';
            });
            setUpdatedStateList(translatedStateList);
        } else if (updatedStateList.length !== 0) {
            setUpdatedStateList([]);
        }
    };

    React.useEffect(() => {
        let stateList: any;
        let response: any;
        if (props && props.items && props.items.length > 0) {
            response = props.items.filter((item: any) => {
                return item.key === 'State';
            });
        }
        if (response && response[0] && response[0].input && response[0].input.props && response[0].input.props.displayData) {
            stateList = response[0].input.props.displayData.filter((option: any) => {
                return option.value !== '';
            });
        }
        if (updatedStateList.length <= 0) {
            void stateListTranslation(stateList);
        } else if (updatedStateList.length <= 2) {
            setUpdatedStateList([]);
        }
    }, [props.items]);

    React.useEffect(() => {
        let cityCheckKOR = false;
        let isNullOrUndefined;
        if (props.items) {
            isNullOrUndefined = items.filter((item: any) => {
                if (defaultCountryRegionId === 'KOR') {
                    cityCheckKOR = true;
                }
                let shouldHideCity;
                if (defaultCountryRegionId === 'KOR' && item.key === 'State') {
                    shouldHideCity = cityCheck.includes(item.input.props.value);
                    if (hideCity !== shouldHideCity) {
                        setHideCity(shouldHideCity);
                    }
                }

                if (cityCheckKOR) {
                    if (
                        item.input.props.additionalAddributes &&
                        item.input.props.additionalAddributes['aria-required'] === true &&
                        item.key !== 'City'
                    ) {
                        if (item.input.props.value === null || item.input.props.value === '') {
                            return item;
                        }
                    }
                } else {
                    if (item.input.props.additionalAddributes && item.input.props.additionalAddributes['aria-required'] === true) {
                        if (item.input.props.value === null || item.input.props.value === '') {
                            return item;
                        }
                    }
                }
            });
        }
        if (isNullOrUndefined && isNullOrUndefined.length > 0) {
            setCustomDisabled(true);
        } else {
            setCustomDisabled(false);
        }
    }, [props]);

    React.useEffect(() => {
        if (smartyFailed) {
            // @ts-ignore
            saveButton.props.onClick(userAddress);
        }
    }, [smartyFailed]);

    const filteredItems = items.filter((item: any) => {
        if (hideCity) {
            return item.key !== 'Phone' && item.key !== 'City';
        } else {
            return item.key !== 'Phone';
        }
    });

    const customKoreaStateOnChange = (functionToExecute: any, data: any) => {
        if (cityCheck.includes(data.target.value)) {
            setHideCity(true);
        } else {
            setHideCity(false);
        }
        functionToExecute(data);
    };

    if (defaultCountryRegionId === 'MEX') {
        const districtIndex = filteredItems.findIndex((item: any) => item.key === 'DistrictName');

        const street2Index = filteredItems.findIndex((item: any) => item.key === 'Street_2');

        if (districtIndex !== -1 && street2Index !== -1) {
            const [removedDistrict] = filteredItems.splice(districtIndex, 1);

            filteredItems.splice(street2Index, 0, removedDistrict);
        }
    }

    const customSetAddress = (address: any) => {
        setInputAddress(address);
    };

    React.useEffect(() => {
        const canSubmit: any = [];
        if (defaultCountryRegionId === 'MEX') {
            filteredItems.map((item: any) => {
                if (
                    item.key === 'Name' ||
                    item.key === 'DistrictName' ||
                    item.key === 'Street' ||
                    item.key === 'ZipCode' ||
                    item.key === 'City'
                ) {
                    return canSubmit.push(item.input.props.value !== undefined && item.input.props.value !== '' ? true : false);
                } else if (item.key === 'State') {
                    return canSubmit.push(item.input.props.value !== '' ? true : false);
                }
            });
            if (canSubmit.includes(false)) {
                setDisabled(true);
            } else if (!canSubmit.includes(false) && disabled === true) {
                setDisabled(false);
            }
        } else if (defaultCountryRegionId === 'PAN') {
            filteredItems.map((item: any) => {
                if (item.key === 'Name' || item.key === 'Street' || item.key === 'ZipCode' || item.key === 'City') {
                    return canSubmit.push(item.input.props.value !== undefined && item.input.props.value !== '' ? true : false);
                } else if (item.key === 'State') {
                    return canSubmit.push(item.input.props.value !== '' ? true : false);
                }
            });
            if (canSubmit.includes(false)) {
                setDisabled(true);
            } else if (!canSubmit.includes(false) && disabled === true) {
                setDisabled(false);
            }
        } else if (defaultCountryRegionId === 'PER') {
            filteredItems.map((item: any) => {
                if (item.key === 'Name' || item.key === 'Street' || item.key === 'ZipCode') {
                    return canSubmit.push(item.input.props.value !== undefined && item.input.props.value !== '' ? true : false);
                } else if (item.key === 'State') {
                    return canSubmit.push(item.input.props.value !== '' ? true : false);
                }
            });
            if (canSubmit.includes(false)) {
                setDisabled(true);
            } else if (!canSubmit.includes(false) && disabled === true) {
                setDisabled(false);
            }
        }
    }, [props]);

    if (loading) {
        return (
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <Waiting />
            </div>
        );
    } else if (showSmarty) {
        if (smartyAddress.country === '') {
            smartyAddress.country = userAddress.ThreeLetterISORegionName ? userAddress.ThreeLetterISORegionName : '';
        }
        return (
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                {smartyAddress && smartyAddress.street && (
                    <div>
                        <h4 style={{ marginBottom: '10px' }}>{resources.smartyStreetAddressHeader}</h4>
                        <div>{`${userAddress && userAddress.Name ? userAddress.Name : ''}`}</div>
                        <div>{`${smartyAddress.street} ${smartyAddress.street2}`}</div>
                        <div>{`${smartyAddress.city}, ${smartyAddress.state} ${smartyAddress.zipcode}${smartyAddress.plusfour ? '-' : ''}${
                            smartyAddress.plusfour
                        }`}</div>
                        <div style={{ marginBottom: '10px' }}>{`${smartyAddress.country}`}</div>
                        {/* @ts-ignore */}
                        {/* <Secondary onClick={() => saveButton.props.onClick(smartyAddress)}> */}
                        <Secondary onClick={() => props.saveAddress(smartyAddress)}>{resources.smartyStreetsAddressButton}</Secondary>
                    </div>
                )}
                <div>
                    <h4 style={{ marginBottom: '10px' }}>{resources.userShippingAddressHeader}</h4>
                    <div>{`${userAddress && userAddress.Name ? userAddress.Name : ''}`}</div>
                    <div>{`${userAddress.Street} ${userAddress.Street_2 || ''}`}</div>
                    <div>{`${userAddress.City}, ${userAddress.State} ${userAddress.ZipCode}`}</div>
                    <div style={{ marginBottom: '10px' }}>{`${userAddress.ThreeLetterISORegionName}`}</div>
                    {/* @ts-ignore */}
                    <Secondary onClick={() => props.saveAddress(userAddress)}>{resources.userAddressButton}</Secondary>
                </div>
            </div>
        );
    } else if (defaultCountryRegionId === 'BRA') {
        return (
            <div>
                <BrazilCheckout
                    customSetAddress={customSetAddress}
                    resources={resources}
                    setIsDisabled={setIsDisabled}
                    currentAddress={userAddressCustom}
                />
                <div className='custom-button-group'>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        {cancelButton && (
                            // @ts-ignore
                            <Ghost style={{ width: '100%' }} onClick={() => cancelButton.props.onClick()}>
                                {/* @ts-ignore */}
                                {cancelButton.props.text}
                            </Ghost>
                        )}
                    </div>
                    <div className='save-button' style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        {saveButton && (
                            <Secondary
                                style={{ width: '100%' }}
                                // @ts-ignore
                                onClick={() => props.saveAddressCustom(inputAddress, defaultCountryRegionId)}
                                disabled={isDisabled}
                            >
                                {/* @ts-ignore */}
                                {saveButton.props.text}
                            </Secondary>
                        )}
                    </div>
                </div>
            </div>
        );
    } else if (defaultCountryRegionId === 'GHA' || defaultCountryRegionId === 'CIV' || defaultCountryRegionId === 'NGA') {
        return (
            <div>
                <AfricaCheckout
                    customSetAddress={customSetAddress}
                    resources={resources}
                    context={context}
                    setIsVisible={setIsVisible}
                    setIsDisabled={setIsDisabled}
                    filteredItems={filteredItems}
                    setUnitName={setUnitName}
                    setStakeNameAddress={setStakeNameAddress}
                    defaultCountryRegionId={defaultCountryRegionId}
                    currentAddress={userAddressCustom}
                />
                {isVisible && (
                    <div className='custom-button-group'>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                            {cancelButton && (
                                // @ts-ignore
                                <Ghost style={{ width: '100%' }} onClick={() => cancelButton.props.onClick()}>
                                    {/* @ts-ignore */}
                                    {cancelButton.props.text}
                                </Ghost>
                            )}
                        </div>
                        <div className='save-button' style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                            {saveButton && (
                                <Secondary
                                    style={{ width: '100%' }}
                                    onClick={() =>
                                        // @ts-ignore
                                        props.saveAddressCustom(inputAddress, defaultCountryRegionId, unitName, stakeNameAddress)
                                    }
                                    disabled={isDisabled}
                                >
                                    {/* @ts-ignore */}
                                    {saveButton.props.text}
                                </Secondary>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    } else if (defaultCountryRegionId === 'PER') {
        let filteredStateList;
        filteredItems.map((item: any) => {
            if (item.key === 'State') {
                const { input } = item;

                // @ts-ignore
                filteredStateList = input.props.displayData;
            }
        });
        return (
            <div>
                <PeruCheckout
                    customSetAddress={customSetAddress}
                    resources={resources}
                    context={context}
                    setIsVisible={setIsVisible}
                    setIsDisabled={setIsDisabled}
                    filteredItems={updatedStateList && updatedStateList.length > 0 ? updatedStateList : filteredStateList}
                    defaultCountryRegionId={defaultCountryRegionId}
                    currentAddress={userAddressCustom}
                />
                <div className='custom-button-group'>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        {cancelButton && (
                            // @ts-ignore
                            <Ghost style={{ width: '100%' }} onClick={() => cancelButton.props.onClick()}>
                                {/* @ts-ignore */}
                                {cancelButton.props.text}
                            </Ghost>
                        )}
                    </div>
                    <div className='save-button' style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        {saveButton && (
                            <Secondary
                                style={{ width: '100%' }}
                                // @ts-ignore
                                onClick={() => props.saveAddressCustom(inputAddress, defaultCountryRegionId)}
                                disabled={isDisabled}
                            >
                                {/* @ts-ignore */}
                                {saveButton.props.text}
                            </Secondary>
                        )}
                    </div>
                </div>
            </div>
        );
    } else if (defaultCountryRegionId === 'URY') {
        let filteredStateList;
        filteredItems.map((item: any) => {
            if (item.key === 'State') {
                const { input } = item;

                // @ts-ignore
                filteredStateList = input.props.displayData;
            }
        });
        return (
            <div>
                <UruguayCheckout
                    customSetAddress={customSetAddress}
                    resources={resources}
                    context={context}
                    setIsVisible={setIsVisible}
                    setIsDisabled={setIsDisabled}
                    filteredItems={updatedStateList && updatedStateList.length > 0 ? updatedStateList : filteredStateList}
                    defaultCountryRegionId={defaultCountryRegionId}
                    currentAddress={userAddressCustom}
                />
                <div className='custom-button-group'>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        {cancelButton && (
                            // @ts-ignore
                            <Ghost style={{ width: '100%' }} onClick={() => cancelButton.props.onClick()}>
                                {/* @ts-ignore */}
                                {cancelButton.props.text}
                            </Ghost>
                        )}
                    </div>
                    <div className='save-button' style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        {saveButton && (
                            <Secondary
                                style={{ width: '100%' }}
                                // @ts-ignore
                                onClick={() => props.saveAddressCustom(inputAddress, defaultCountryRegionId)}
                                disabled={isDisabled}
                            >
                                {/* @ts-ignore */}
                                {saveButton.props.text}
                            </Secondary>
                        )}
                    </div>
                </div>
            </div>
        );
    } else if (defaultCountryRegionId === 'CHL') {
        // let filteredStateList;
        // filteredItems.map(item => {
        //     if (item.key === 'State') {
        //         const { input } = item;

        //         // @ts-ignore
        //         filteredStateList = input.props.displayData;
        //     }
        // });
        let filteredStateList: any;
        filteredItems.map((item: any) => {
            if (item.key === 'State') {
                // @ts-ignore
                filteredStateList = item.input.props.displayData.filter((option: any) => {
                    return stateCheckListChl.some((item: any) => item.value === option.key && item.label === option.value);
                });
            }
        });

        return (
            <div>
                <ChileCheckout
                    customSetAddress={customSetAddress}
                    resources={resources}
                    context={context}
                    setIsVisible={setIsVisible}
                    setIsDisabled={setIsDisabled}
                    filteredItems={updatedStateList && updatedStateList.length > 0 ? updatedStateList : filteredStateList}
                    defaultCountryRegionId={defaultCountryRegionId}
                    currentAddress={userAddressCustom}
                />
                <div className='custom-button-group'>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        {cancelButton && (
                            // @ts-ignore
                            <Ghost style={{ width: '100%' }} onClick={() => cancelButton.props.onClick()}>
                                {/* @ts-ignore */}
                                {cancelButton.props.text}
                            </Ghost>
                        )}
                    </div>
                    <div className='save-button' style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        {saveButton && (
                            <Secondary
                                style={{ width: '100%' }}
                                // @ts-ignore
                                onClick={() => props.saveAddressCustom(inputAddress, defaultCountryRegionId)}
                                disabled={isDisabled}
                            >
                                {/* @ts-ignore */}
                                {saveButton.props.text}
                            </Secondary>
                        )}
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <Node {...AddressForm}>
                {heading}
                {filteredItems.map((item: IAddressAddItem) => {
                    const { AddressItem, key, label, alert, input } = item;
                    // @ts-ignore
                    if (input.props.id === 'shipping_addressthreeletterisoregionname') {
                        return (
                            <Node {...AddressItem} key={key}>
                                {label}
                                {/* {alert} */}
                                {/* @ts-ignore */}
                                {alert && alert.props.message && <label style={{ color: 'red' }}>{alert.props.message}</label>}
                                <select
                                    //@ts-ignore
                                    {...input.props}
                                    style={{
                                        display: 'block',
                                        width: '100%',
                                        border: '1px solid black',
                                        boxSizing: 'border-box !important',
                                        borderRadius: '2px',
                                        fontSize: '18px',
                                        lineHeight: '24px',
                                        fontWeight: 'normal',
                                        height: '48px'
                                    }}
                                    disabled
                                >
                                    {/* @ts-ignore */}
                                    {input.props.displayData.map((data: any) => {
                                        return (
                                            // @ts-ignore
                                            <option value={data.key} key={data.key} selected={data.key === input.props.value}>
                                                {data.value}
                                            </option>
                                        );
                                    })}
                                </select>
                                {/* {input} */}
                            </Node>
                        );
                    } else if (item.key === 'State' && defaultCountryRegionId === 'KOR') {
                        let filteredStateList: any;
                        if (context.request.locale === 'en-US') {
                            // @ts-ignore
                            filteredStateList = input.props.displayData.filter((option: any) => {
                                return stateCheckList.some(item => item.value === option.key && item.label === option.value);
                            });
                        } else {
                            // @ts-ignore
                            filteredStateList = input.props.displayData.filter((option: any) => {
                                return stateCheckListKo.some(item => item.value === option.key && item.label === option.value);
                            });
                        }
                        // input.props.displayData;
                        return (
                            <Node {...AddressItem} key={key}>
                                {label}
                                {/* {alert} */}
                                {/* @ts-ignore */}
                                {alert && alert.props.message && <label style={{ color: 'red' }}>{alert.props.message}</label>}
                                {updatedStateList && updatedStateList.length > 0 ? (
                                    <select
                                        //@ts-ignore
                                        {...input.props}
                                        // @ts-ignore
                                        onChange={e => customKoreaStateOnChange(input.props.onChange, e)}
                                        style={{
                                            display: 'block',
                                            width: '100%',
                                            border: '1px solid black',
                                            boxSizing: 'border-box !important',
                                            borderRadius: '2px',
                                            fontSize: '18px',
                                            lineHeight: '24px',
                                            fontWeight: 'normal',
                                            height: '48px'
                                        }}
                                    >
                                        <option value={''} selected={true} disabled />
                                        {/* @ts-ignore */}
                                        {updatedStateList.map((data: any) => {
                                            return (
                                                // @ts-ignore
                                                <option value={data.key} key={data.key} selected={data.key === input.props.value}>
                                                    {data.value}
                                                </option>
                                            );
                                        })}
                                    </select>
                                ) : (
                                    <select
                                        //@ts-ignore
                                        {...input.props}
                                        // @ts-ignore
                                        onChange={e => customKoreaStateOnChange(input.props.onChange, e)}
                                        style={{
                                            display: 'block',
                                            width: '100%',
                                            border: '1px solid black',
                                            boxSizing: 'border-box !important',
                                            borderRadius: '2px',
                                            fontSize: '18px',
                                            lineHeight: '24px',
                                            fontWeight: 'normal',
                                            height: '48px'
                                        }}
                                    >
                                        <option value={''} selected={true} disabled />
                                        {/* @ts-ignore */}
                                        {filteredStateList.map((data: any) => {
                                            return (
                                                // @ts-ignore
                                                <option value={data.key} key={data.key} selected={data.key === input.props.value}>
                                                    {data.value}
                                                </option>
                                            );
                                        })}
                                    </select>
                                )}
                                {/* {input} */}
                            </Node>
                        );
                    } else if (item.key === 'State' && defaultCountryRegionId === 'VNM') {
                        return (
                            <Node {...AddressItem} key={key}>
                                {label}
                                {/* {alert} */}
                                {/* @ts-ignore */}
                                {alert && alert.props.message && <label style={{ color: 'red' }}>{alert.props.message}</label>}
                                {updatedStateList && updatedStateList.length > 0 ? (
                                    <select
                                        //@ts-ignore
                                        {...input.props}
                                        // @ts-ignore
                                        onChange={e => customKoreaStateOnChange(input.props.onChange, e)}
                                        style={{
                                            display: 'block',
                                            width: '100%',
                                            border: '1px solid black',
                                            boxSizing: 'border-box !important',
                                            borderRadius: '2px',
                                            fontSize: '18px',
                                            lineHeight: '24px',
                                            fontWeight: 'normal',
                                            height: '48px'
                                        }}
                                    >
                                        <option value={''} selected={true} disabled />
                                        {/* {filteredStateList.map((data: any) => { */}
                                        {/* @ts-ignore */}
                                        {updatedStateList.map((data: any) => {
                                            return (
                                                // @ts-ignore
                                                <option value={data.key} key={data.key} selected={data.key === input.props.value}>
                                                    {data.value}
                                                </option>
                                            );
                                        })}
                                    </select>
                                ) : (
                                    <select
                                        //@ts-ignore
                                        {...input.props}
                                        // @ts-ignore
                                        onChange={e => customKoreaStateOnChange(input.props.onChange, e)}
                                        style={{
                                            display: 'block',
                                            width: '100%',
                                            border: '1px solid black',
                                            boxSizing: 'border-box !important',
                                            borderRadius: '2px',
                                            fontSize: '18px',
                                            lineHeight: '24px',
                                            fontWeight: 'normal',
                                            height: '48px'
                                        }}
                                    >
                                        <option value={''} selected={true} disabled />
                                        {/* {filteredStateList.map((data: any) => { */}
                                        {/* @ts-ignore */}
                                        {input.props.displayData.map((data: any) => {
                                            return (
                                                // @ts-ignore
                                                <option value={data.key} key={data.key} selected={data.key === input.props.value}>
                                                    {data.value}
                                                </option>
                                            );
                                        })}
                                    </select>
                                )}
                                {/* {input} */}
                            </Node>
                        );
                    } else if (item.key === 'State' && defaultCountryRegionId === 'ARG') {
                        // @ts-ignore
                        const filteredStateList = input.props.displayData.filter((option: any) => {
                            return ArgState.some(item => item.key === option.key && item.value === option.value);
                        });
                        // input.props.displayData;
                        return (
                            <Node {...AddressItem} key={key}>
                                {label}
                                {/* {alert} */}
                                {/* @ts-ignore */}
                                {alert && alert.props.message && <label style={{ color: 'red' }}>{alert.props.message}</label>}
                                {updatedStateList && updatedStateList.length > 0 ? (
                                    <select
                                        //@ts-ignore
                                        {...input.props}
                                        style={{
                                            display: 'block',
                                            width: '100%',
                                            border: 'none',
                                            boxSizing: 'border-box !important',
                                            borderRadius: '2px',
                                            fontSize: '18px',
                                            lineHeight: '24px',
                                            fontWeight: 'normal',
                                            height: '48px'
                                        }}
                                    >
                                        <option value={''} selected={true} disabled />
                                        {/* @ts-ignore */}
                                        {updatedStateList.map((data: any) => {
                                            return (
                                                // @ts-ignore
                                                <option value={data.key} key={data.key} selected={data.key === input.props.value}>
                                                    {data.value}
                                                </option>
                                            );
                                        })}
                                    </select>
                                ) : (
                                    <select
                                        //@ts-ignore
                                        {...input.props}
                                        style={{
                                            display: 'block',
                                            width: '100%',
                                            border: 'none',
                                            boxSizing: 'border-box !important',
                                            borderRadius: '2px',
                                            fontSize: '18px',
                                            lineHeight: '24px',
                                            fontWeight: 'normal',
                                            height: '48px'
                                        }}
                                    >
                                        <option value={''} selected={true} disabled />
                                        {/* @ts-ignore */}
                                        {filteredStateList.map((data: any) => {
                                            return (
                                                // @ts-ignore
                                                <option value={data.key} key={data.key} selected={data.key === input.props.value}>
                                                    {data.value}
                                                </option>
                                            );
                                        })}
                                    </select>
                                )}
                                {/* {input} */}
                            </Node>
                        );
                    } else if (item.key === 'State' && defaultCountryRegionId === 'GTM') {
                        // @ts-ignore
                        if (input && input.props && input.props.displayData) {
                            // @ts-ignore
                            input.props.displayData.map((item: any) => {
                                if (item.key === '') {
                                    const value = item.value.split(' ');
                                    value.pop();
                                    const popValue = value.join(' ');
                                    item.value = `${popValue} ${resources.addressDepartmentLabel}`;
                                }
                            });
                        }
                        // @ts-ignore
                        if (label && label.props && label.props.text) {
                            // @ts-ignore
                            label.props.text = `${resources.addressDepartmentLabel} *`;
                        }
                        // @ts-ignore
                        if (alert && alert.props && alert.props.message) {
                            // @ts-ignore
                            alert.props.message = resources.addressDepartmentRequiredErrorMessage;
                        }
                        return (
                            <Node {...AddressItem} key={key}>
                                {label}
                                {/* {alert} */}
                                {/* @ts-ignore */}
                                {alert && alert.props.message && <label style={{ color: 'red' }}>{alert.props.message}</label>}
                                {input}
                            </Node>
                        );
                    } else if (item.key === 'State' && defaultCountryRegionId === 'MEX') {
                        // @ts-ignore
                        if (label && label.props && label.props.text) {
                            // @ts-ignore
                            label.props.text = resources.addressStateProvinceLabel;
                        }
                        // @ts-ignore
                        if (alert && alert.props && alert.props.message) {
                            // @ts-ignore
                            alert.props.message = resources.addressStateProvinceRequiredErrorMessage;
                        }
                        return (
                            <Node {...AddressItem} key={key}>
                                {label}
                                {/* {alert} */}
                                {/* @ts-ignore */}
                                {alert && alert.props.message && <label style={{ color: 'red' }}>{alert.props.message}</label>}
                                {updatedStateList && updatedStateList.length > 0 ? (
                                    <select
                                        //@ts-ignore
                                        {...input.props}
                                        style={{
                                            display: 'block',
                                            width: '100%',
                                            border: 'none',
                                            boxSizing: 'border-box !important',
                                            borderRadius: '2px',
                                            fontSize: '18px',
                                            lineHeight: '24px',
                                            fontWeight: 'normal',
                                            height: '48px'
                                        }}
                                    >
                                        <option value={''} selected={true} disabled />
                                        {/* @ts-ignore */}
                                        {updatedStateList.map((data: any) => {
                                            return (
                                                // @ts-ignore
                                                <option value={data.key} key={data.key} selected={data.key === input.props.value}>
                                                    {data.value}
                                                </option>
                                            );
                                        })}
                                    </select>
                                ) : (
                                    input
                                )}
                                {/* {input} */}
                            </Node>
                        );
                    } else if (item.key === 'DistrictName' && defaultCountryRegionId === 'MEX') {
                        // @ts-ignore
                        if (label && label.props && label.props.text) {
                            // @ts-ignore
                            label.props.text = resources.addressColoniaLabel;
                        }
                        // @ts-ignore
                        if (alert && alert.props && alert.props.message) {
                            // @ts-ignore
                            alert.props.message = resources.addressColoniaRequiredErrorMessage;
                        }
                        return (
                            <Node {...AddressItem} key={key}>
                                {label}
                                {/* {alert} */}
                                {/* @ts-ignore */}
                                {alert && alert.props.message && <label style={{ color: 'red' }}>{alert.props.message}</label>}
                                {input}
                            </Node>
                        );
                    } else if (item.key === 'State') {
                        return (
                            <Node {...AddressItem} key={key}>
                                {label}
                                {alert}
                                {updatedStateList && updatedStateList.length > 0 ? (
                                    <select
                                        //@ts-ignore
                                        {...input.props}
                                        style={{
                                            display: 'block',
                                            width: '100%',
                                            border: 'none',
                                            boxSizing: 'border-box !important',
                                            borderRadius: '2px',
                                            fontSize: '18px',
                                            lineHeight: '24px',
                                            fontWeight: 'normal',
                                            height: '48px'
                                        }}
                                    >
                                        <option value={''} selected={true} disabled />
                                        {/* @ts-ignore */}
                                        {updatedStateList.map((data: any) => {
                                            return (
                                                // @ts-ignore
                                                <option value={data.key} key={data.key} selected={data.key === input.props.value}>
                                                    {data.value}
                                                </option>
                                            );
                                        })}
                                    </select>
                                ) : (
                                    input
                                )}
                                {/* {input} */}
                            </Node>
                        );
                    } else {
                        return (
                            <Node {...AddressItem} key={key}>
                                {label}
                                {/* {alert} */}
                                {/* @ts-ignore */}
                                {alert && alert.props.message && <label style={{ color: 'red' }}>{alert.props.message}</label>}
                                {input}
                            </Node>
                        );
                    }
                })}
                {hasError && (
                    <Node {...error.AddressError}>
                        {error.title}
                        {error.message}
                    </Node>
                )}
                {defaultCountryRegionId === 'MEX' || defaultCountryRegionId === 'PAN' ? (
                    <div className='custom-button-group'>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                            {cancelButton && (
                                // @ts-ignore
                                <Ghost style={{ width: '100%' }} onClick={() => cancelButton.props.onClick()}>
                                    {/* @ts-ignore */}
                                    {cancelButton.props.text}
                                </Ghost>
                            )}
                        </div>
                        <div className='save-button' style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                            {saveButton && (defaultCountryRegionId === 'USA' || defaultCountryRegionId === 'CAN') ? (
                                // @ts-ignore
                                <Secondary style={{ width: '100%' }} onClick={() => props.saveAddress('', false)}>
                                    {/* @ts-ignore */}
                                    {saveButton.props.text}
                                </Secondary>
                            ) : saveButton ? (
                                // @ts-ignore
                                <Secondary style={{ width: '100%' }} onClick={() => props.saveAddress()} disabled={disabled}>
                                    {/* @ts-ignore */}
                                    {saveButton.props.text}
                                </Secondary>
                            ) : null}
                        </div>
                    </div>
                ) : (
                    <div className='custom-button-group'>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                            {cancelButton && (
                                // @ts-ignore
                                <Ghost style={{ width: '100%' }} onClick={() => cancelButton.props.onClick()}>
                                    {/* @ts-ignore */}
                                    {cancelButton.props.text}
                                </Ghost>
                            )}
                        </div>
                        <div className='save-button' style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                            {saveButton && (defaultCountryRegionId === 'USA' || defaultCountryRegionId === 'CAN') ? (
                                // @ts-ignore
                                <Secondary style={{ width: '100%' }} onClick={() => props.saveAddress(userAddressCustom, false)}>
                                    {/* @ts-ignore */}
                                    {saveButton.props.text}
                                </Secondary>
                            ) : saveButton ? (
                                // @ts-ignore
                                <Secondary
                                    style={{ width: '100%' }}
                                    disabled={customDisabled}
                                    onClick={() => props.saveAddress(userAddressCustom)}
                                >
                                    {/* @ts-ignore */}
                                    {saveButton.props.text}
                                </Secondary>
                            ) : null}
                        </div>
                    </div>
                )}
            </Node>
        );
    }
};

/**
 * Account Management Address View Component.
 * @param props - Props.
 * @returns - AccountAddressManagement Module.
 */
const AccountManagementAddressView: React.FC<IAccountManagementAddressViewProps> = props => {
    const [isVisible, setIsVisible] = React.useState(false);
    const [isListVisible, setIsListVisible] = React.useState(false);
    const [isDuplicate, setIsDuplicate] = React.useState(false);
    const { AccountAddressManagement, viewState, showAddressList, showAddOrUpdateAddress, screenReaderNotification } = props;

    React.useEffect(() => {
        if (
            screenReaderNotification &&
            // @ts-ignore
            screenReaderNotification.props &&
            // @ts-ignore
            screenReaderNotification.props.children &&
            isDuplicate === false
        ) {
            setIsVisible(true);
            setIsDuplicate(true);
        }
    }, [props]);

    React.useEffect(() => {
        if (viewState.isShowAddresList) {
            setIsListVisible(true);
        } else {
            setIsListVisible(false);
        }
    }, [viewState]);

    return (
        <>
            {/* @ts-ignore */}
            {isVisible && (
                <Info style={{ marginBottom: '10px' }}>
                    {/* @ts-ignore */}
                    <div style={{ marginTop: '3px' }}>{screenReaderNotification.props.children}</div>
                </Info>
            )}
            <Module {...AccountAddressManagement}>
                {/* {isListVisible && (
                    <AddressLists
                        {...showAddressList}
                        resources={props.resources}
                        setIsVisible={setIsVisible}
                        isDuplicate={setIsDuplicate}
                        context={props.context}
                    />
                )} */}
                <div style={{ display: isListVisible ? 'block' : 'none' }}>
                    <AddressLists
                        {...showAddressList}
                        resources={props.resources}
                        setIsVisible={setIsVisible}
                        isDuplicate={setIsDuplicate}
                        context={props.context}
                    />
                </div>
                {viewState.isShowAddOrUpdateAddress && (
                    <AddressAddUpdate
                        {...showAddOrUpdateAddress}
                        isFinalSubmit={props.finalSubmit}
                        // getSmarty={getSmarty}
                        smartyAddress={props.smartyAddress}
                        final={props.finalSubmit}
                        // inputAddress={userInputAddress}
                        // saveAddress={submitAddress}
                        saveAddress={props.saveAddress}
                        resources={props.resources}
                        onCancel={props.onCancel}
                        userAddressCustom={props.addUpdateAddress}
                        context={props.context}
                        saveAddressCustom={props.saveAddressCustom}
                        // @ts-ignore
                        loading={props.loading}
                        // @ts-ignore
                        showSmarty={props.showSmarty}
                        userAddress={props.addUpdateAddress}
                    />
                )}
            </Module>
        </>
    );
};

export default AccountManagementAddressView;
